export default __webpack_public_path__ + "static/media/sign-up-bg.7803f443.png";